import { Box, Typography } from "@material-ui/core";
import { useBorrowerPortalMediaQueries } from "@roc/feature-app-core";

export const TitleComp = ({
  title
}: {
  title: string | React.ReactNode;
}) => {
  const { isSmallScreen } = useBorrowerPortalMediaQueries();
  return (
    <>
      <Typography variant={isSmallScreen ? 'h5' : 'h4'}>{title}</Typography>
      <Box width={"100%"} height={'1px'} bgcolor={"#ddd"} mt={1}></Box>
    </>
  )
}